import { gql } from '@apollo/client'

export const showingUpdatesSubscription = gql`
  subscription ShowingUpdatesSubscription($contactId: Int!, $taskId: Int) {
    showingUpdates(contactId: $contactId, taskId: $taskId) {
      id
    }
  }
`

export const threadUpdatesSubscription = gql`
  subscription ThreadUpdatesSubscription($threadId: Int!) {
    threadUpdates(threadId: $threadId) {
      id
    }
  }
`

export const contactUpdatesSubscription = gql`
  subscription ContactUpdatesSubscription($contactId: Int!) {
    contactUpdates(contactId: $contactId) {
      id
    }
  }
`
export const messageUpdatesSubscription = gql`
  subscription MessageUpdatesSubscription($threadId: Int!) {
    messageUpdates(threadId: $threadId) {
      id
    }
  }
`
export const calUpdatesSubscription = gql`
  subscription CalUpdatesSubscription($threadId: Int!) {
    calUpdates(threadId: $threadId) {
      id
    }
  }
`
